<template>
  <multiselect
    v-model="selectedRecords"
    :options="records"
    :multiple="true"
    @input="updateSelected"
    label="selectTitle"
    track-by="selectTitle"
    :placeholder="options?.placeholder || 'Выберите вариант'"
    select-label="Выбрать"
    deselect-label="Удалить">
  </multiselect>
</template>

<script>

import Multiselect from 'vue-multiselect'

export default {
  props: ['records', 'options'],
  components: {
    Multiselect,
  },
  data() {
    return {
      selectedRecords: [],
    }
  },
  methods: {
    updateSelected(e) {
      if (!this.options || !this.options?.useAllSelect) return;
      const inserted = [...this.selectedRecords].pop();
      if (inserted.id === -1) {
        this.selectedRecords = [inserted];
      } else {
        this.selectedRecords = this.selectedRecords.filter((s) => s.id !== -1);
      }
    }
  }
}

</script>
